import SettingsTab from "./settings_tab";

export default function AccSettingHeader({ userData, activeTab }) {
    return <div class="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

        <div class="flex md:gap-8 gap-4 items-center md:p-10 p-6">


            <div className="relative md:w-20 md:h-20 w-12 h-12 shrink-0">
                <img src={userData['userPic']} alt="" className="w-full h-full absolute object-cover" />
            </div>

            <div class="flex-1">
                <h3 class="md:text-xl text-base font-semibold text-black dark:text-white"> {userData['username']} </h3>
                <p class="text-sm text-blue-600 mt-1 font-normal">{userData['firstName']} {userData['lastName']}</p>
            </div>

        </div>

        <hr class="border-t border-gray-100 dark:border-slate-700" />

        <SettingsTab userId={userData['userId']} activeTab={activeTab} />

    </div>
}